import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-responsive-ui'

class More extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.state = {
            pageNumber: 2
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this._calcScroll.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this._calcScroll)
    }

    _calcScroll() {
        if (this.refs !== undefined && this.refs.More !== undefined){
            var yPosition = parseInt(this.refs.More.getBoundingClientRect().top);
            if (yPosition < window.innerHeight) {
                this.handleClick()
            } 
        }  
    }

    render() {
        return (
            <div className="load-more-container" ref="More">
            {this.props.ableToLoadMore && <Button disabled action={() => this.handleClick()}>
                Load more posts
            </Button>}
            {!this.props.ableToLoadMore && <h4>No more posts to load for the moment</h4>}
            </div>
        )
    }

    handleClick = () => {
        this.setState( prevState => ({pageNumber: prevState.pageNumber + 1}))
        this.props.loadMore(this.state.pageNumber)
    }

}

More.propTypes = {
    history: PropTypes.object,
    loadMore: PropTypes.func,
    ableToLoadMore: PropTypes.bool,
};

export default More;



// WEBPACK FOOTER //
// ./src/components/more.js